import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { AdminVaccineRoutingModule } from './admin-vaccine.routing';
import { AdminVaccineComponent } from './admin-vaccine.component';
import { SharedModule } from '../../shared/shared.module';
import { AdminVaccineReceivedComponent } from './admin-vaccine-received/admin-vaccine-received.component';
import { OtherAdminVaccineReceivedComponent } from './other-admin-vaccine-received/other-admin-vaccine-received.component';
import { FutureVaccineComponent } from './future-vaccine/future-vaccine.component';

@NgModule({
    declarations: [
        AdminVaccineComponent,
        AdminVaccineReceivedComponent,
        OtherAdminVaccineReceivedComponent,
        FutureVaccineComponent
    ],
    imports: [AdminVaccineRoutingModule, SharedModule, ReactiveFormsModule, FormsModule, CommonModule],
    providers: [],
    bootstrap: []
})
export class AdminVaccineModule {
}




// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/admin-vaccine/admin-vaccine.module.ts